import { mfLogoBaseUrl } from '../../../../../env'
import { GROUPED_STATIC_TEXT_ROLE } from '../../../../../components/ui-components/NameValueTableRow'
import { roundOffAndFormatNumberWithCurrency } from '../../../../../utils/utils'
import { formatDigitsForSpeech } from '../../../../../utils/a11ySpeech'
import { FolioDetail } from '../../../types/investmentApi.types'

export const FolioNumber = ({ folioDetails, isLast = false }: { folioDetails: FolioDetail; isLast?: boolean }) => {
  return (
    <div className='flex flex-col w-full'>
      <div
        className={`flex items-center justify-between pt-4 cursor-pointer hover:bg-[#f8fafc] transition-colors duration-200 pl-5`}
      >
        <div className='flex gap-3 flex-1'>
          <div className='w-[40px] h-[40px] rounded-[12px]'>
            <img
              src={`${mfLogoBaseUrl}${folioDetails?.folioLogo}`}
              alt='Folio Logo'
              className='w-full h-full object-contain'
              onError={(e) => {
                const target = e?.target as HTMLImageElement
                target.style.display = 'none'
              }}
            />
          </div>
          <div
            className={`flex flex-col gap-[2px] flex-1 border-b border-[#F0F4F7] pr-5 pb-5 ${isLast ? 'border-b-0' : ''}`}
          >
            <div className={`text-[14px] font-[500] text-[#232323] leading-[130%]`}>{folioDetails?.folioName}</div>
            <div className={`text-[13px] font-[400] text-[#6A6E6E] leading-[150%]`}>
              <span className='font-[500]'>
                {roundOffAndFormatNumberWithCurrency(folioDetails?.folioWealth?.amount)}
              </span>{' '}
              available
            </div>
            <div className='flex gap-2 items-center pt-2'>
              {folioDetails.source === 'EXTERNAL' && (
                <div className='text-[#6A6E6E] font-[400] text-[13px] rounded-[8px] w-max bg-[#F0F4F7] px-2 pt-[3px] pb-[5px]'>
                  External
                </div>
              )}
              <div
                role={GROUPED_STATIC_TEXT_ROLE}
                aria-label={`Folio number, ${formatDigitsForSpeech(folioDetails?.folioNumber)}`}
                className='text-[#6A6E6E] font-[400] text-[13px] rounded-[8px] w-max bg-[#F0F4F7] px-2 pt-[3px] pb-[5px]'
              >
                <span aria-hidden='true'>Folio #{folioDetails?.folioNumber}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
